import React, { useEffect, useState } from 'react'
import Header from '../Component/Header'
import Sidebar from '../Component/Sidebar'
import axios from 'axios'
import baseUrl from '../Constant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'

function PatientList() {
    const [patientList, setPatientList] = useState([])
    const [loading, setLoading] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [message, setMessage] = useState()
    const [color, setColor] = useState()
    const [squery, setQuery] = useState([])

    const getPatientList = (() => {
        setLoading(true)
        const token = JSON.parse(localStorage.getItem("token"))
        axios.get(`${baseUrl}/accounts/patient-list`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                setPatientList(res.data.patient)
                setLoading(false);

            })
            .catch((error) => {
                console.log(error)
                setLoading(false)
            })
    })

    const handleDelete = (uid) => {
        const token = JSON.parse(localStorage.getItem('token'))
        axios.get(`${baseUrl}/accounts/del-patient/${uid}`, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 3000)
                    getPatientList();
                    setIsOpen(false)
                }
                else {
                    setColor("#ff0000");
                    console.log('red')
                    setTimeout(() => {
                        setMessage('')
                        setColor("");
                    }, 2000);
                }
            })
            .catch((error) => {
                console.log(error)

            })
    }

    const handleSearch = (() => {
        const query = squery;
        const token = JSON.parse(localStorage.getItem('token'))
        axios.post(`${baseUrl}/accounts/patient-list`, { query }, { headers: { "Authorization": `Bearer ${token}` } })
            .then((res) => {
                console.log(res.data)
                setPatientList(res.data.patient)
                setMessage(res.data.message)
                if (res.data.status === 200) {
                    setColor("#008000");
                }
                else {
                    setColor("#ff0000");
                    setTimeout(() => {
                        setMessage('')
                        setColor('')
                    }, 3000)
                    console.log('red')
                }
            })
            .catch((error) => {
                console.log(error)

            })
    })

    useEffect(() => {
        getPatientList()
    }, [])

    return (
        <div>
            <Header />
            <div className='d-flex'>
                <div>
                    <Sidebar />
                </div>
                <div className='container-fluid' style={{ backgroundColor: 'rgb(42 127 155 / 24%)', height: '100vh' }}>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='p-3' style={{ textAlign: "center" }}>
                                <input type="text" value={squery} placeholder='Search By Patient' style={{ padding: "8px", borderRadius: '8px', width: "30%" }} onChange={(e) => setQuery(e.target.value)} />

                                <button type='submit' className='btn btn-info ms-3 text-white fw-medium' onClick={handleSearch}>
                                    Search
                                </button>
                            </div>


                            {/* <div className='p-3' style={{textAlign:"center"}}>
                                <input type="text" placeholder='Search By Case' style={{ padding: "10px", borderRadius: '8px', width: "50%" }} />
                            </div> */}

                            <div className='row p-4'>
                                {
                                    message && <div style={{ marginBottom: 10 }}>
                                        <div style={{ fontSize: 20, fontWeight: 600, color: 'white', textAlign: "center", paddingHorizontal: 20, backgroundColor: `${color}` }}>{message}</div>
                                    </div>
                                }
                                <div className='card '>
                                    <div className='card-body'>
                                        <div className="active-member">
                                            <div className="table-responsive">
                                                < table className="table table-xs" >
                                                    <thead>
                                                        <tr>
                                                            <th>ID</th>
                                                            <th>Patient Name</th>
                                                            <th>Phone No.</th>
                                                            <th>Age</th>
                                                            <th>Address</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    {
                                                        patientList && patientList.map((item, index) => {

                                                            return (
                                                                <tbody key={patientList.uid}>
                                                                    <tr>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.patient_name}</td>
                                                                        <td>{item.phone_number}</td>
                                                                        <td>{item.age}</td>
                                                                        <td>{item.address}</td>
                                                                        <td>
                                                                            <Link to={`/add-case/${item.uid}`}>
                                                                                <button className='btn btn-info' style={{ margin: "10px", color: "#fff" }}>
                                                                                    Add Case
                                                                                </button>
                                                                            </Link>

                                                                            <Link to={`/edit-patient/${item.uid}`}>
                                                                                <button className='btn btn-danger'>
                                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                                </button>
                                                                            </Link>

                                                                            <button className='btn btn-danger' style={{ margin: "10px" }} onClick={() => setIsOpen(true)} >
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </button>
                                                                            {isOpen && (
                                                                                <div className='confirmation-modal'>
                                                                                    <p>Are you sure you want to delete?</p>
                                                                                    <button className='btn btn-danger' onClick={() => handleDelete(item.uid)}>Yes</button>
                                                                                    <button className='btn btn-success' onClick={() => setIsOpen(false)}>No</button>
                                                                                </div>
                                                                            )}


                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            )
                                                        })
                                                    }

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PatientList;